
export default function TermChip({ t, attr, openEdit }) {
  return (
    <div className="flex items-center gap-2 bg-white border border-gray2 rounded-md px-2 py-1 shadow-sm">
      <div className="flex items-center gap-2">
        {attr.type === 'color' ? (
          <span className="w-6 h-6 rounded-full border" style={{ background: t.meta && t.meta.color ? t.meta.color : '#ddd' }} aria-hidden></span>
        ) : attr.type === 'image' ? (
          (t.meta && t.meta.image) ? (
            <img src={t.meta.image} alt={t.name} className="w-8 h-8 object-cover rounded" />
          ) : (
            <span className="w-8 h-8 inline-block bg-gray-100 rounded" />
          )
        ) : (
          <span className="px-2 py-1 text-sm bg-gray-100 rounded">{t.meta && t.meta.select ? t.meta.select : t.name}</span>
        )}
      </div>
      <div className="text-base">
        <div className="font-medium text-gray-800">{t.name}</div>
      </div>
      <div className="ml-2">
        <div className="flex items-center gap-1">
          <button type="button" onClick={openEdit} className="text-[9px] px-1 py-0.5 rounded bg-theme hover:bg-blue-700 text-white leading-[2]">Quick Edit</button>
        </div>
      </div>
    </div>
  );
}
